import React, { useEffect, useRef } from 'react';

import { BarChart } from 'echarts/charts';
import { AriaComponent, GridComponent, LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components';
import { init, use as registerECharts } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

import { Box } from '@mui/material';

import { emailChart } from './emailChart';

registerECharts([
  BarChart,
  AriaComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  CanvasRenderer,
]);

type Props = { rows: Array<Record<string, unknown>> };

/** The source worksheet has selection/highlighting, but no filter action. */
export default function EmailWorksheet({ rows }: Props) {
  const node = useRef<HTMLDivElement>(null);
  const instance = useRef<ReturnType<typeof init> | undefined>(undefined);
  const latestRows = useRef(rows);
  latestRows.current = rows;
  useEffect(() => {
    if (!node.current) {
      return undefined;
    }
    const chart = init(node.current, undefined, { renderer: 'canvas' });
    instance.current = chart;
    const observer = new ResizeObserver(() => {
      chart.resize();
      chart.setOption(emailChart(latestRows.current, false, node.current?.clientWidth ?? 1100), { notMerge: true });
    });
    observer.observe(node.current);
    return () => {
      observer.disconnect();
      chart.dispose();
      instance.current = undefined;
    };
  }, []);
  useEffect(() => {
    instance.current?.setOption(emailChart(rows, false, node.current?.clientWidth ?? 1100), { notMerge: true });
  }, [rows]);
  return (
    <Box
      ref={node}
      role="img"
      aria-label="Clicks by Date. Stacked daily product clicks. Select a mark to highlight it; totals and filters stay unchanged."
      sx={{ width: '100%', height: { xs: 350, sm: 'clamp(380px, calc(100dvh - 330px), 560px)' }, minWidth: 0 }}
    />
  );
}
